export default {
  VENDOR: 'BRAND',
  SELLER: 'SELLER_CENTRAL_ENTITY',
};
